import React from "react";

const footer = () => {
    return (
        <footer className="page-footer font-small bg-dark">
            <div className="footer-copyright text-center text-light py-3">
                <span><img style={{width:"40px"}} src={require('../assets/s1.png')}  alt={"Logo"}/></span>
                <span>© 2023 Copyright: All rights reserved.</span>
            </div>
        </footer>
    );
}
export default footer;
